/**
 * @generated SignedSource<<46f4648f357aa599efb8e50cece1b490>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IconType = "ACTIVITY" | "AIRPLAY" | "ALERT_CIRCLE" | "ALERT_OCTAGON" | "ALERT_TRIANGLE" | "ALIGN_CENTER" | "ALIGN_JUSTIFY" | "ALIGN_LEFT" | "ALIGN_RIGHT" | "ANCHOR" | "APERTURE" | "ARCHIVE" | "ARROW_DOWN" | "ARROW_DOWN_CIRCLE" | "ARROW_DOWN_LEFT" | "ARROW_DOWN_RIGHT" | "ARROW_LEFT" | "ARROW_LEFT_CIRCLE" | "ARROW_RIGHT" | "ARROW_RIGHT_CIRCLE" | "ARROW_UP" | "ARROW_UP_CIRCLE" | "ARROW_UP_LEFT" | "ARROW_UP_RIGHT" | "AT_SIGN" | "AWARD" | "BAR_CHART" | "BAR_CHART_2" | "BATTERY" | "BATTERY_CHARGING" | "BELL" | "BELL_FILL" | "BELL_OFF" | "BLUETOOTH" | "BOLD" | "BOOK" | "BOOKMARK" | "BOOK_OPEN" | "BOX" | "BRIEFCASE" | "CALENDAR" | "CAMERA" | "CAMERA_OFF" | "CAST" | "CHECK" | "CHECK_CIRCLE" | "CHECK_SQUARE" | "CHEVRONS_DOWN" | "CHEVRONS_LEFT" | "CHEVRONS_RIGHT" | "CHEVRONS_UP" | "CHEVRON_DOWN" | "CHEVRON_LEFT" | "CHEVRON_RIGHT" | "CHEVRON_UP" | "CHROME" | "CIRCLE" | "CLIPBOARD" | "CLOCK" | "CLOUD" | "CLOUD_DRIZZLE" | "CLOUD_LIGHTNING" | "CLOUD_OFF" | "CLOUD_RAIN" | "CLOUD_SNOW" | "CODE" | "CODEPEN" | "CODESANDBOX" | "COFFEE" | "COLUMNS" | "COMMAND" | "COMPASS" | "COPY" | "CORNER_DOWN_LEFT" | "CORNER_DOWN_RIGHT" | "CORNER_LEFT_DOWN" | "CORNER_LEFT_UP" | "CORNER_RIGHT_DOWN" | "CORNER_RIGHT_UP" | "CORNER_UP_LEFT" | "CORNER_UP_RIGHT" | "CPU" | "CREDIT_CARD" | "CROP" | "CROSSHAIR" | "CUSTOM_CART" | "CUSTOM_CONCIERGE" | "CUSTOM_EXPERIENCES" | "CUSTOM_FEED" | "CUSTOM_PROFILE" | "CUSTOM_SHOP" | "DATABASE" | "DELETE" | "DISC" | "DIVIDE" | "DIVIDE_CIRCLE" | "DIVIDE_SQUARE" | "DOLLAR_SIGN" | "DOWNLOAD" | "DOWNLOAD_CLOUD" | "DRIBBBLE" | "DROPLET" | "EDIT" | "EDIT_2" | "EDIT_3" | "EXTERNAL_LINK" | "EYE" | "EYE_OFF" | "FACEBOOK" | "FAST_FORWARD" | "FEATHER" | "FIGMA" | "FILE" | "FILE_MINUS" | "FILE_PLUS" | "FILE_TEXT" | "FILM" | "FILTER" | "FLAG" | "FOLDER" | "FOLDER_MINUS" | "FOLDER_PLUS" | "FOR_YOU" | "FRAMER" | "FROWN" | "GIFT" | "GITHUB" | "GITLAB" | "GIT_BRANCH" | "GIT_COMMIT" | "GIT_MERGE" | "GIT_PULL_REQUEST" | "GLOBE" | "GRID" | "HARD_DRIVE" | "HASH" | "HEADPHONES" | "HEART" | "HELP_CIRCLE" | "HEXAGON" | "HOME" | "IMAGE" | "INBOX" | "INFO" | "INSTAGRAM" | "ITALIC" | "KEY" | "LAYERS" | "LAYOUT" | "LIFE_BUOY" | "LINK" | "LINKEDIN" | "LINK_2" | "LIST" | "LOADER" | "LOCK" | "LOG_IN" | "LOG_OUT" | "MAIL" | "MAP" | "MAP_PIN" | "MAXIMIZE" | "MAXIMIZE_2" | "MEH" | "MENU" | "MESSAGE_CIRCLE" | "MESSAGE_SQUARE" | "MESSAGE_SQUARE_FILL" | "MIC" | "MIC_OFF" | "MINIMIZE" | "MINIMIZE_2" | "MINUS" | "MINUS_CIRCLE" | "MINUS_SQUARE" | "MONITOR" | "MOON" | "MORE_HORIZONTAL" | "MORE_VERTICAL" | "MOUSE_POINTER" | "MOVE" | "MUSIC" | "NAVIGATION" | "NAVIGATION_2" | "OCTAGON" | "PACKAGE" | "PAPERCLIP" | "PAUSE" | "PAUSE_CIRCLE" | "PEN_TOOL" | "PERCENT" | "PHONE" | "PHONE_CALL" | "PHONE_FORWARDED" | "PHONE_INCOMING" | "PHONE_MISSED" | "PHONE_OFF" | "PHONE_OUTGOING" | "PIE_CHART" | "PLAY" | "PLAY_CIRCLE" | "PLUS" | "PLUS_CIRCLE" | "PLUS_SQUARE" | "POCKET" | "POWER" | "PRINTER" | "RADIO" | "REFRESH_CCW" | "REFRESH_CW" | "REPEAT" | "REWIND" | "ROTATE_CCW" | "ROTATE_CW" | "RSS" | "SAVE" | "SCISSORS" | "SEARCH" | "SEND" | "SERVER" | "SETTINGS" | "SHARE" | "SHARE_2" | "SHIELD" | "SHIELD_OFF" | "SHOPPING_BAG" | "SHOPPING_CART" | "SHUFFLE" | "SIDEBAR" | "SKIP_BACK" | "SKIP_FORWARD" | "SLACK" | "SLASH" | "SLIDERS" | "SMARTPHONE" | "SMILE" | "SPEAKER" | "SQUARE" | "STAR" | "STOP_CIRCLE" | "SUN" | "SUNRISE" | "SUNSET" | "TABLE" | "TABLET" | "TAG" | "TARGET" | "TERMINAL" | "THERMOMETER" | "THUMBS_DOWN" | "THUMBS_UP" | "TOGGLE_LEFT" | "TOGGLE_RIGHT" | "TOOL" | "TRASH" | "TRASH_2" | "TRELLO" | "TRENDING_DOWN" | "TRENDING_UP" | "TRIANGLE" | "TRUCK" | "TV" | "TWITCH" | "TWITTER" | "TYPE" | "UMBRELLA" | "UNDERLINE" | "UNLOCK" | "UPLOAD" | "UPLOAD_CLOUD" | "USER" | "USERS" | "USER_CHECK" | "USER_MINUS" | "USER_PLUS" | "USER_X" | "VIDEO" | "VIDEO_OFF" | "VOICEMAIL" | "VOLUME" | "VOLUME_1" | "VOLUME_2" | "VOLUME_2_FILL" | "VOLUME_X" | "VOLUME_X_FILL" | "WATCH" | "WIFI" | "WIFI_OFF" | "WIND" | "X" | "X_CIRCLE" | "X_OCTAGON" | "X_SQUARE" | "YOUTUBE" | "ZAP" | "ZAP_OFF" | "ZOOM_IN" | "ZOOM_OUT" | "%future added value";
export type KinnLanguageCode = "AR" | "DE" | "EN" | "ES" | "FR" | "NL" | "PT" | "%future added value";
export type NavigationTitleMode = "HIDDEN" | "LOGO" | "PAGE_TITLE" | "%future added value";
export type NavigationTitlePosition = "CENTER" | "LEFT" | "%future added value";
export type TabType = "ACCOUNT" | "FORUM" | "FOR_YOU" | "NOTIFICATIONS" | "SHOP" | "WEB" | "%future added value";
export type UpdateTabConfigInput = {
  brandId: string;
  isTabBarTitleEnabled: boolean;
  navTitleMode: NavigationTitleMode;
  navTitlePosition: NavigationTitlePosition;
  tabInputs: ReadonlyArray<GraphQLBrandAppTabConfigInput>;
};
export type GraphQLBrandAppTabConfigInput = {
  customName: string;
  customUrl?: string | null;
  icon: IconType;
  index?: number | null;
  localizations: ReadonlyArray<LocalizedUrlInput>;
  type: TabType;
};
export type LocalizedUrlInput = {
  languageCode: KinnLanguageCode;
  text: string;
  url?: string | null;
};
export type TabsCard2UpdateTabConfigMutation$variables = {
  input: UpdateTabConfigInput;
};
export type TabsCard2UpdateTabConfigMutation$data = {
  readonly updateTabConfig: {
    readonly " $fragmentSpreads": FragmentRefs<"TabsCard2_brand">;
  };
};
export type TabsCard2UpdateTabConfigMutation = {
  response: TabsCard2UpdateTabConfigMutation$data;
  variables: TabsCard2UpdateTabConfigMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TabsCard2UpdateTabConfigMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BrandType",
        "kind": "LinkedField",
        "name": "updateTabConfig",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TabsCard2_brand"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TabsCard2UpdateTabConfigMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BrandType",
        "kind": "LinkedField",
        "name": "updateTabConfig",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BrandAppConfigType",
            "kind": "LinkedField",
            "name": "appConfig",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "supportedLanguages",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "enableLanguageSpecificContent",
                "storageKey": null
              },
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "BrandAppConfigBuildNavigationType",
                "kind": "LinkedField",
                "name": "buildNavigation",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isTabBarTitleEnabled",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "navTitleMode",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "navTitlePosition",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "eligibleTabTypes",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "GraphQLBrandAppTabConfig",
                "kind": "LinkedField",
                "name": "tabs",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "type",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "customName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LocalizedUrlType",
                    "kind": "LinkedField",
                    "name": "localizations",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "languageCode",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "text",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "url",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "customUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "icon",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "domain",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "befb8d219fb1e7493066a9628c85b440",
    "id": null,
    "metadata": {},
    "name": "TabsCard2UpdateTabConfigMutation",
    "operationKind": "mutation",
    "text": "mutation TabsCard2UpdateTabConfigMutation(\n  $input: UpdateTabConfigInput!\n) {\n  updateTabConfig(input: $input) {\n    ...TabsCard2_brand\n    id\n  }\n}\n\nfragment TabsCard2_brand on BrandType {\n  ...useBrandLanguages_brand\n  id\n  domain\n  appConfig {\n    id\n    buildNavigation {\n      id\n      isTabBarTitleEnabled\n      navTitleMode\n      navTitlePosition\n      eligibleTabTypes\n    }\n    tabs {\n      id\n      type\n      customName\n      localizations {\n        languageCode\n        text\n        url\n      }\n      customUrl\n      icon\n    }\n  }\n}\n\nfragment useBrandLanguages_brand on BrandType {\n  appConfig {\n    supportedLanguages\n    enableLanguageSpecificContent\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "8f45061f38ee1070dc3a5fa0ced0dfe7";

export default node;
